var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sk-wave",style:(_vm.style)},_vm._l((5),function(_,index){return _c('div',{key:index})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }